import sectionStyles from "@/asserts/styles/formSection.module.less";
import type { EditInquiryFormValues } from "../../type";
import { Empty, Form, Row, Tag } from "antd";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { SearchPurchaseRequest } from "./SearchPurchaseRequest";
import { useEffect, useState } from "react";
import styles from "./PurchaseRequestFormFields.module.less";
import { CloseOutlined } from "@ant-design/icons";
import { SrmPurchaseRequestVo } from "@/types/apis";
import { useTranslation } from "react-i18next";

type SelectedItem = {
  id: number;
  applicationNo: string;
};
export function PurchaseRequestFormFields({ disabled }: { disabled: boolean }) {
  const { t } = useTranslation("inquiryManagement");
  const form = Form.useFormInstance<EditInquiryFormValues>();

  const [selectedPurchaseRequests, setSelectedPurchaseRequests] = useState<
    SelectedItem[]
  >([]);

  const purchaseOrderList = Form.useWatch("purchaseOrderList", form);

  useEffect(() => {
    if (!purchaseOrderList || purchaseOrderList.length === 0) {
      return;
    }
    setSelectedPurchaseRequests(
      purchaseOrderList.map((s) => {
        return {
          id: s.id,
          applicationNo: s.applicationNo,
        };
      }),
    );
  }, [purchaseOrderList]);

  const onSelect = (rows?: SrmPurchaseRequestVo[]) => {
    if (!rows) {
      return;
    }
    setSelectedPurchaseRequests((prev) => {
      const newPurchaseRequests = rows.filter(
        (row) => !prev.some((item) => item.id === row.id),
      );
      const next = [...prev, ...newPurchaseRequests].slice(0, 3);
      form.setFieldValue(
        "purchaseRequestIds",
        next.map((item) => item.id).join(","),
      );
      return next;
    });
  };

  return (
    <div className={sectionStyles.formSection}>
      <Form.Item<EditInquiryFormValues> name="purchaseRequestIds" hidden />
      <Form.Item<EditInquiryFormValues> name="purchaseOrderList" hidden />
      <ModalSectionHeader title={t("绑定需求申请单(如有)")} />

      <div className={sectionStyles.sectionBody}>
        <Row hidden={disabled}>
          {selectedPurchaseRequests.length < 3 && (
            <SearchPurchaseRequest onSelect={onSelect} />
          )}
        </Row>

        {selectedPurchaseRequests.length === 0 && <Empty />}

        <div className={styles.purchaseRequestRecordContainer}>
          {selectedPurchaseRequests.map((item) => (
            <Tag
              key={item.id}
              className={styles.tag}
              closeIcon={disabled ? null : <CloseOutlined />}
              onClose={() => {
                const next = selectedPurchaseRequests.filter(
                  (i) => i.id !== item.id,
                );
                form.setFieldValue(
                  "purchaseRequestIds",
                  next.map((item) => item.id),
                );
                setSelectedPurchaseRequests(next);
              }}
            >
              {item.applicationNo}
            </Tag>
          ))}
        </div>
      </div>
    </div>
  );
}
